/* eslint-disable no-nested-ternary */
import React from 'react';
import Box from '@mui/material/Box';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { ReactComponent as NoDatasetFound } from '../../assets/images/NoDatasetFound.svg';
import { ReactComponent as NoDataFound } from '../../assets/images/NoDataFound.svg';

function NoDataFoundComponent({
  page,
  rows,
  globalFilter,
  data,
  enablePagination,
}) {
  return (
    <Box>
      {data?.length <= 0 && isEmpty(globalFilter) ? (
        <Box
          display="flex"
          flex="1"
          justifyContent="center"
          alignItems="center"
        >
          <Box>
            <NoDatasetFound />
            <Typography
              variant="subtitle1"
              textAlign="center"
              sx={(theme) => ({
                mt: '24px',
                '&:focus-visible': {
                  outline: 'none',
                  border: `2px solid ${theme?.palette?.primary?.main} !important`,
                },
              })}
              tabIndex={0}
            >
              No data present.
            </Typography>
          </Box>
        </Box>
      ) : !isEmpty(globalFilter) &&
        (enablePagination ? page : rows).length <= 0 ? (
        <Box
          display="flex"
          flex="1"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          mt="30px"
        >
          <NoDataFound />
          <Typography
            variant="subtitle1"
            textAlign="center"
            sx={(theme) => ({
              py: '24px',
              '&:focus-visible': {
                outline: 'none',
                border: `2px solid ${theme?.palette?.primary?.main} !important`,
              },
            })}
            tabIndex={0}
          >
            No matching result found.
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}

NoDataFoundComponent.propTypes = {
  rows: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  page: PropTypes.oneOfType([PropTypes.array]).isRequired,
  data: PropTypes.oneOfType([PropTypes.array]).isRequired,
  // eslint-disable-next-line react/require-default-props
  globalFilter: PropTypes.string,
  enablePagination: PropTypes.bool.isRequired,
};

export default NoDataFoundComponent;
